import { type PartnerCreateDto, postPartners } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const partnerMutationsResource = Resources.base.partner.mutations;

export const useCreatePartner = () => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((data: PartnerCreateDto) => postPartners(data)),
		onError: (error) => {
			console.error(
				`${t(partnerMutationsResource.partnerCreateError)}:`,
				error,
			);
		},
		onSuccess: () => {
			toast.success(t(partnerMutationsResource.partnerCreateSuccess));
			queryClient.invalidateQueries({ queryKey: ["PARTNERS_LIST"] });
		},
	});
};
